import { useTranslation } from "react-i18next";
import styles from "./Education.module.css";
import { SectionTitle } from "../../PresentationalComponents/SectionTitle";
import { BicepsFlexed, BrainCircuit, GraduationCap } from "lucide-react";

const formatter = new Intl.NumberFormat("fa-IR");

const EducationDictionary = {
  en: {
    sectionTitle: "Education",
    sectionNum: "06",
    thesis: "Thesis",
    thesisTitle: "Thesis Title: ",
    thesisSupervisor: "Thesis Supervisor: ",
    thesisAdvisor: "Thesis Advisor: ",
    educations: [
      {
        university: (
          <a target="_blank" href="http://en.mazust.ac.ir/">
            University of Science and Technology of Mazandaran
          </a>
        ),
        education: "B.Sc. Computer Engineering - Software Engineering",
        location: "IRAN - MAZANDARAN",
        date: "Sep.2016 - Sep.2020",
        image: "imgs/Education/Mazust.webp",
        thesis: {
          title:
            "Persian Natural Language Processing of Chatbots Implemented on Botpress platform.",
          supervisor: (
            <a
              target="_blank"
              href="https://www.linkedin.com/in/reza-javanmard-alitappeh-7423b255/"
            >
              Prof. Reza Javanmard
            </a>
          ),
          consultingAdvisor: "Dr Pirgazi",
          advisor: [
            <a
              target="_blank"
              href="https://scholar.google.com/citations?user=Z45CpqwAAAAJ&hl=en"
            >
              Prof. Malihe Danesh
            </a>,
            <a
              target="_blank"
              href="https://scholar.google.com/citations?user=m-WcYgIAAAAJ&hl=en"
            >
              Dr. Ali Ghanbari
            </a>,
          ],
        },
      },
    ],
  },
  fa: {
    sectionTitle: "تحصیلات تکمیلی",
    sectionNum: formatter.format("0") + formatter.format("6"),
    thesis: "پایان‌نامه",
    thesisTitle: "عنوان پایان‌نامه: ",
    thesisSupervisor: "استاد راهنما: ",
    thesisAdvisor: "با همکاری اساتید: ",

    educations: [
      {
        university: (
          <a target="_blank" href="http://en.mazust.ac.ir/">
            دانشگاه علم و فناوری مازندران
          </a>
        ),
        education: "کارشناسی مهندسی کامپیوتر - گرایش نرم‌افزار",
        location: "ایران - مازندران",
        date: "مهر۱۳۹۵ - مهر۱۳۹۹",
        image: "imgs/Education/Mazust.webp",
        thesis: {
          title:
            "پردازش زبان طبیعی فارسی در چت‌بات پیاده سازی شده در پلتفرم بات‌پرس",
          supervisor: (
            <a
              target="_blank"
              href="https://www.linkedin.com/in/reza-javanmard-alitappeh-7423b255/"
            >
              دکتر رضا جوانمرد
            </a>
          ),
          consultingAdvisor: "دکتر پیرگزی",
          advisor: [
            <a
              target="_blank"
              href="https://scholar.google.com/citations?user=Z45CpqwAAAAJ&hl=en"
            >
              {"دکتر ملیحه دانش، "}
            </a>,
            <a
              target="_blank"
              href="https://scholar.google.com/citations?user=m-WcYgIAAAAJ&hl=en"
            >
              دکتر علی قنبری
            </a>,
          ],
        },
      },
    ],
  },
};

export function Education() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <section className={styles.sectionContainer}>
      <div className={styles.header}>
        <SectionTitle
          text={EducationDictionary[lang].sectionTitle}
          num={EducationDictionary[lang].sectionNum}
        />
      </div>
      <section className={styles.universitySection}>
        <div className={styles.universityContainer}>
          <div className={styles.firstColumn}>
            <div className={styles.upperLine}></div>
            <div className={styles.middleDot}></div>
            <div className={styles.lowerLine}></div>
          </div>
          <div className={styles.secondColumn}>
            <h6>{EducationDictionary[lang].educations[0].date}</h6>
            <h4>
              <strong>
                {EducationDictionary[lang].educations[0].education}
              </strong>
            </h4>
            <h5>{EducationDictionary[lang].educations[0].university}</h5>
            <h5>{EducationDictionary[lang].educations[0].location}</h5>
          </div>
          <div className={styles.thirdColumn}>
            <img src={EducationDictionary[lang].educations[0].image} />
          </div>
        </div>
        <div className={styles.thesisContainer}>
          <div>
            <div className={styles.thesisRow}>
              <div>
                <GraduationCap />
                <label>{EducationDictionary[lang].thesisTitle}</label>
              </div>
              <h3>{EducationDictionary[lang].educations[0].thesis.title}</h3>
            </div>
            <div className={styles.thesisRow}>
              <div>
                <BicepsFlexed />
                <label>{EducationDictionary[lang].thesisSupervisor}</label>
              </div>
              <h4>
                {EducationDictionary[lang].educations[0].thesis.supervisor}
              </h4>
            </div>
            <div className={styles.thesisRow}>
              <div>
                <BrainCircuit />
                <label>{EducationDictionary[lang].thesisAdvisor}</label>
              </div>
              <h4>
                {EducationDictionary[lang].educations[0].thesis.advisor.map(
                  (a, index) => (
                    <>{a}</>
                  ),
                )}
              </h4>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}
